import { render, staticRenderFns } from "./logIndex.vue?vue&type=template&id=828f4a46&"
import script from "./logIndex.vue?vue&type=script&lang=js&"
export * from "./logIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports